import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-notification-info",
  templateUrl: "./notification-info.component.html",
  styleUrls: ["./notification-info.component.css"],
})
export class NotificationInfoComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
